import { render, staticRenderFns } from "./BranchStatus.vue?vue&type=template&id=65bac704&"
import script from "./BranchStatus.vue?vue&type=script&lang=js&"
export * from "./BranchStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports